import React from 'react';
import NumberFormatReact from 'react-number-format';
import { cn } from 'helpers/css';

const NumberFormat = (props) => {
  //! State

  //! Function

  //! Render
  return (
    <NumberFormatReact
      displayType='text'
      thousandSeparator={true}
      renderText={(value) => <span className={cn('tw-inline-block', props.className)}>{value}</span>}
      {...props}
    />
  );
};

export default React.memo(NumberFormat);
